import { FC } from 'react';
import { LayoutEditor } from './components/LayoutEditor';

/**
 * IO template settings, nested under Media Plans.
 *
 * The parent route supplies the page header and content wrapper, so this
 * renders only the editor.
 */
const Templates: FC = () => <LayoutEditor />;

export default Templates;
